import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAlignTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-align-top"} maskId="square-filled-radius-0-stroke-1-IconLayoutAlignTop"><path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM7 7V8H17V7H7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutAlignTop;
